import React from 'react';
import PropTypes from 'prop-types';

import PDPImageAndTextOptionDisplay from 'components/consumer/PDP/PDPImageAndTextOptionDisplay';

const PDPImageAndTextSelector = ({
  isEditOrder = false,
  imageOrTextVariant = 'regular',
  mode = 'pdp',
  optionId = null,
  productId = null,
  slug,
  variant = 'regular',
}) => (
  <PDPImageAndTextOptionDisplay
    hideFlyout
    isEditOrder={isEditOrder}
    imageOrTextVariant={imageOrTextVariant}
    mode={mode}
    optionId={optionId}
    productId={productId}
    slug={slug}
    variant={variant}
  />
);

PDPImageAndTextSelector.propTypes = {
  imageOrTextVariant: PropTypes.oneOf(['regular', 'textOnly']),
  mode: PropTypes.oneOf(['pdp', 'quickview']),
  optionId: PropTypes.number,
  productId: PropTypes.number,
  slug: PropTypes.string,
  isEditOrder: PropTypes.bool,
  variant: PropTypes.oneOf(['regular', 'fullWidth']),
};

export default PDPImageAndTextSelector;
